<div class="item">
  <div class="row justify-content-center">
    <div class="col-12 d-flex justify-content-center" *ngFor="let _ of repeatArray">
      <ngx-skeleton-loader
        [appearance]="apperance"
        [count]="gridCount"
        animation="progress-dark"
        [theme]="{
          'border-radius': `${borderRadius}px`,
          width: `${widthSizeInPixels}px`,
          height: `${HeightSizeInPixels}px`,
          margin: '10px',
          'background-color': color,
          animations: animation,
        }" />
    </div>
  </div>
</div>
